import env from '../../utils/env';
import request from './request';
import requestJson from './requestJson';

export const uploadImageToCdn = (formData) => {
  const endpoint = `${env.aceApi}/1/admin/products/image`;
  return request(endpoint, 'POST', {}, formData);
};

export const uploadMultipleImages = (formData) => {
  const endpoint = `${env.aceApi}/1/admin/products/images`;
  return requestJson(endpoint, 'POST', { Accept: '*/*' }, formData);
};

export const deleteImagesFromCdn = (fileUrls) => {
  const endpoint = `${env.aceApi}/1/admin/products/images`;
  const data = JSON.stringify(fileUrls);
  return request(
    endpoint,
    'DELETE',
    { 'Content-Type': 'application/json' },
    data
  );
};

export const uploadAndConvertToPng = (formData) => {
  const endpoint = `${env.aceApi}/1/admin/products/images/convert-upload`;
  return requestJson(endpoint, 'POST', { Accept: '*/*' }, formData);
};
